<template>
    <div class="flex justify-between">
        <div class="flex gap-2 items-center">
            <div>
                <RedesignBaseIcon
                    name="Phone"
                    class="text-gray"
                />
            </div>
            <div
                style="max-width: 200px"
                class="truncate"
            >
                <span class="font-medium">
                    {{ call.callername || call.CallerID }}
                </span>
            </div>
            <div>
                <redesign-tag
                    :tag-content="timerTagContent"
                />
            </div>
        </div>

        <div class="flex items-center gap-4 text-xs">
            <button
                v-show="!isSubscribed(call.IvrUniqueID)"
                class="text-primary hover:underline"
                @click="subscribeToCall(botId, call)"
            >
                {{ $t('general.livetranscript') }}
            </button>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import RedesignBaseIcon from '@/components/RedesignBaseComponents/RedesignBaseIcon.vue'
import RedesignTag from '@/components/RedesignBaseComponents/RedesignTag.vue'
import { useTimer } from '@/composables/useTimer.js'
import { addChat, isSubscribed } from '@/composables/useChatsData'
import { subscribeToBotCall } from '@/plugins/initRealTimeSdk'
import { VoicebotEventDataCall } from '@voicenter-team/events-sdk'

const props = defineProps<{
    call: VoicebotEventDataCall
    botId: number
}>()

const { timerDisplayTime, startTimer } = useTimer(false)

const timerTagContent = computed(() => {
    return [ { text: timerDisplayTime.value } ]
})


const callStarted = computed(() => {
    return props.call.callStarted_UTC_CLIENT
})

async function subscribeToCall (botID: number, call:VoicebotEventDataCall) {
    await subscribeToBotCall(botID, call.IvrUniqueID)
    addChat(botID, call.IvrUniqueID)
}

startTimer(callStarted)
</script>
